import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../../services/authguard-service';
import { DiscoveryComponent } from './discovery.component';

const appRoutes: Routes = [
  {
    path: ':discoverytype', component: DiscoveryComponent, canActivate: [AuthGuard]
  },
  {
    path: ':discoverytype/:viewtype/:param1/:param2/:param3', component: DiscoveryComponent, canActivate: [AuthGuard]
  }
];

export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(appRoutes);
